import { useState } from "react";
import deleteImage from "../../assets/images/delete.png";
import lodingImage from "../../assets/images/loadingSpin.png";
import {
  useDeleteTodoMutation,
  useGetTodosQuery
} from "../../features/todoApi/todoApiSlice";

export default function CompleteTodoHeader() {
  const [clearAllLoading, setClearAllLoading] = useState(false);
  const { data: todos } = useGetTodosQuery({ complete: true });
  const [deleteTodo] = useDeleteTodoMutation();

  const clearHeandler = () => {
    setClearAllLoading(true);
    let promiseArray = [];

    todos?.forEach((todo) => {
      promiseArray.push(deleteTodo({ id: todo?.id, complete: true }).unwrap());
    });
    Promise.all(promiseArray).then(() => setClearAllLoading(false));
  };

  return (
    <div>
      <ul className="flex justify-between items-end mb-2 text-xs text-gray-500">
        <li>
          <h3 className="font-medium text-lg text-black">Completed Tasks</h3>
        </li>
        <li
          className={`cursor-pointer flex items-center gap-1 ${
            clearAllLoading && "animate-pulse text-gray-700"
          }`}
          onClick={clearHeandler}
        >
          <img
            className={`w-4 h-4 ${
              clearAllLoading && "bg-bottom animate-spin !bg-cover m-0 p-0"
            }`}
            src={clearAllLoading ? lodingImage : deleteImage}
            alt="Clear"
          />
          <span>Clear completed</span>
        </li>
      </ul>
    </div>
  );
}
